import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/beef";

const links = [
  { label: "Our Standard", href: "#standard" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
  { label: "Who We Are", href: "#ranch", accent: true },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="bg-cream border-b border-linen flex justify-center py-4" data-testid="logo-banner">
        <a href="#top" data-testid="logo-banner-link">
          <img
            src="/images/logo-full.png"
            alt="Waters & Field Cattle — Angus steer with cross on the horizon over water ripples"
            className="h-24 lg:h-28 w-auto"
          />
        </a>
      </div>
      <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className={`sticky top-0 z-50 transition-[background-color,box-shadow] duration-300 ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl border-b border-white/20 shadow-sm"
          : "bg-white/40 backdrop-blur-md border-b border-white/10"
      }`}
      data-testid="main-nav"
    >
      <div className="bg-forest text-cream" data-testid="call-banner">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2 flex items-center justify-center gap-2">
          <Phone className="w-3.5 h-3.5" strokeWidth={2} />
          <a href={BUSINESS.phoneHref} data-testid="call-banner-link" className="text-sm font-semibold tracking-wide hover:underline underline-offset-4">
            Call or Text Stacy — {BUSINESS.phone}
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center">
        <nav className="hidden md:flex items-center gap-10 flex-1 justify-center">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-base transition-[color] duration-200 hover:underline underline-offset-8 decoration-2 decoration-clay/60 ${
                l.accent ? "font-semibold text-forest hover:text-clay" : "font-medium text-forest/80 hover:text-forest"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#reserve"
          data-testid="nav-reserve-btn"
          className="rounded-full bg-clay text-cream text-sm font-semibold px-5 py-2.5 whitespace-nowrap ml-auto md:ml-0 hover:bg-claydark hover:-translate-y-0.5 hover:shadow-md transition-[background-color,transform,box-shadow] duration-200"
        >
          Reserve your beef
        </a>
      </div>
      </motion.header>
    </>
  );
};
